import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'claim-quantity-input',
  templateUrl: './claim-quantity-input.component.html',
  styleUrls: ['./claim-quantity-input.component.less'],
})
export class ClaimQuantityInputComponent {
  private _quantity = 0;
  private _quantityInitialized = false;

  tempQuantity: number | undefined;
  @Input() moq = 1;
  @Input() max = Number.MAX_SAFE_INTEGER;
  @Input() errorTypes: string[] = [];
  /** 非空时在输入框内展示该文本（如 "-"），并禁用编辑 */
  @Input() displayText?: string;
  /** false 时仅初始化一次 quantity，避免父组件反复 @Input 覆盖正在编辑的值 */
  @Input() syncFromParent = true;
  /** true 时在输入过程中实时触发 quantityChange（用于联动计算） */
  @Input() liveUpdate = false;
  @Output() quantityChange = new EventEmitter<number>();
  @Output() quantityBlur = new EventEmitter<number>();

  @Input('quantity')
  set quantityInput(val: number) {
    if (this.syncFromParent || !this._quantityInitialized) {
      this._quantity = val ?? 0;
      this._quantityInitialized = true;
    }
  }

  get quantity(): number {
    return this._quantity;
  }

  set quantity(val: number) {
    this._quantity = val ?? 0;
  }

  get hasDisplayText(): boolean {
    return this.displayText != null && this.displayText !== '';
  }

  get isMinusPlusDisabled(): boolean {
    return this.errorTypes.includes('invalid_error') || this.hasDisplayText;
  }

  adjustQuantityToMoq(): void {
    const moq = this.moq === 0 ? 1 : this.moq;
    if (this.quantity === 0 || this.quantity < moq) {
      this.quantity = moq;
    } else if (this.quantity % moq !== 0) {
      this.quantity = Math.ceil(this.quantity / moq) * moq;
    }
    this.quantity = Math.min(this.quantity, this.max);
    this.quantityChange.emit(this.quantity);
  }

  decrease(): void {
    if (this.isMinusPlusDisabled) {
      return;
    }
    const moq = this.moq === 0 ? 1 : this.moq;
    const newQuantity = this.quantity - moq;
    if (newQuantity >= moq) {
      this.quantity = newQuantity;
      this.quantityChange.emit(this.quantity);
    }
  }

  increase(): void {
    if (this.isMinusPlusDisabled) {
      return;
    }
    const moq = this.moq === 0 ? 1 : this.moq;
    this.quantity = Math.min(this.quantity + moq, this.max);
    this.quantityChange.emit(this.quantity);
  }

  onBlur(): void {
    if (this.hasDisplayText) {
      return;
    }
    if (this.tempQuantity === null || this.tempQuantity === undefined) {
      return;
    }
    this.quantity = this.tempQuantity;
    this.adjustQuantityToMoq();
    this.quantityBlur.emit(this.quantity);
  }

  onInputChange(value: number): void {
    if (this.hasDisplayText) {
      return;
    }
    this.tempQuantity = value;
    if (this.liveUpdate) {
      const num = Number(value);
      if (!isNaN(num) && num > 0) {
        this.quantityChange.emit(num);
      }
    }
  }
}
